import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import Button from 'components/Button';
import TitleInput from 'components/TitleInput';
import useReloadPage from 'hooks/useReloadPage';

const ConfirmAccountInfomation = ({ form, back, listFacilities }) => {
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  useReloadPage('');

  const getFacilityName = (value) => {
    if (!value || !listFacilities) return '';
    const facility = listFacilities.find((item) => item.value === value);
    if (facility) return facility.label;
    return '';
  };

  return (
    <div className="w-indicators mx-auto text-black/85">
      <fieldset>
        <TitleInput className="!mt-0 font-bold" text={t('NAME_THERAPIST')} required={true} />
        <p className="break-all">{form.values.name}</p>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={t('EMAIL_ADDRESS')} required={true} />
        <p className="break-all">{form.values.email}</p>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={t('PASSWORD')} required={true}>
          <button type="button" onClick={() => setShowPassword(!showPassword)} className="ml-4">
            {showPassword ? (
              <img src={require('assets/resources/EyeVisibilityOn.svg').default} alt="eye visibility on" width={16} height={16} />
            ) : (
              <img src={require('assets/resources/EyeVisibilityOff.svg').default} alt="eye visibility off" width={16} height={16} />
            )}
          </button>
        </TitleInput>
        <div className="break-all w-100 flex flex-wrap">
          {showPassword
            ? form.values.password
            : new Array(form.values.password.length).fill('・').map((item, index) => <div key={`password-${index}`}>{item}</div>)}
        </div>
      </fieldset>

      <fieldset>
        <TitleInput className="font-bold" text={t('FACILITY_NAME')} required={true} />
        <p className="break-all">{getFacilityName(form.values.facility_id)}</p>
      </fieldset>

      <Button
        onClick={() => {
          form.handleSubmit();
        }}
        className="w-60 h-9.5 mt-8 mx-auto"
        color="primary"
        type="button"
        text={t('CREATE_ACCOUNT')}
      />
      <Button onClick={back} className="w-60 h-9.5 mt-6 mx-auto" color="outline" type="button" text={t('BACK_TO_ENTER')} />
    </div>
  );
};

export default React.memo(ConfirmAccountInfomation);
